import { useTranslation } from 'next-i18next'
import { DefaultSeoProps, NextSeo } from 'next-seo'
import { useRouter } from 'next/router'
import { FC } from 'react'

import { MetaType } from '@/types/TextData'

const Meta: FC<MetaType> = ({
  title = null,
  description = null,
  image_width = null,
  image_height = null,
  image_url = null
}) => {
  const router = useRouter()
  const {
    i18n: { language }
  } = useTranslation()

  const props: DefaultSeoProps = {
    openGraph: {
      url: `${process.env.SITE_URL}${language === 'ru' ? '' : '/' + language}${
        router.asPath === '/' ? '' : router.asPath
      }`,
      type: process.env.APP_TYPE,
      locale: `${language}_${language.toUpperCase()}`,
      siteName: process.env.SITE_NAME
    }
  }

  if (title) {
    props.title = title
    props.openGraph = {
      ...props.openGraph,
      title
    }
  }

  if (description) {
    props.description = description
    props.openGraph = {
      ...props.openGraph,
      description
    }
  }

  if (image_url && image_width && image_height && title) {
    props.openGraph = {
      ...props.openGraph,
      images: [
        {
          url: image_url,
          width: image_width,
          height: image_height,
          alt: title,
          type: 'image/jpeg'
        }
      ]
    }
  }

  return <NextSeo {...props} />
}
export default Meta
